import { render } from "./Index.vue?vue&type=template&id=f4b3d59e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=f4b3d59e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f4b3d59e"

export default script